import { Helmet } from "react-helmet-async";
import { HelmetProvider } from "react-helmet-async";

export default function PopunderHead() {
  return (
    <Helmet>
      {/* <script
        type="text/javascript"
        src="//pl28237572.effectivegatecpm.com/20/96/f0/2096f072aaf88cd447ba8b516c60a8db.js"
      ></script> */}
    </Helmet>
  );
}
